import React, { useContext } from "react"
import { Navigate, Outlet } from "react-router-dom"
import {AuthContext} from '../context/Auth'

export const PrivateRoute = () => {
    const {signed, isAdmin, authChecked} = useContext(AuthContext)

    // Mesma corrida de hidratação do AdminOnly (que já cobre isso na maioria dos casos, mas
    // esta guarda decide sozinha do mesmo jeito) — não decide nada antes do localStorage
    // terminar de ser lido. Ver Gotchas.
    if (!authChecked) {
        return null
    }

    // Verifica se está logado E se é admin
    return signed && isAdmin ? <Outlet/> : <Navigate to='/'/>
}